<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_940')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc"
         v-bind="formItemLayout">
        <a-form-item :label="$t('scope.text_406')">
          <base-select
            v-decorator="decorators.billing_account_id"
            class="w-100"
            resource="billing_accounts"
            :params="accountParams"
            :disabled="params.accountId ? true : false"
            :select-props="{ placeholder: $t('scope.text_941') }"
            :initLoaded.sync="accountResultLoaded" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_942')">
          <a-select v-decorator="decorators.type">
            <a-select-option v-for="item in typeOptions" :key="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('scope.text_647')">
          <a-input-number
            v-decorator="decorators.amount"
            :precision="2"
            :min="0" />
        </a-form-item>
        <a-form-item :label="$t('scope.voucher_manager.min_bill_amount')">
          <a-input-number
            v-decorator="decorators.min_bill_amount"
            :precision="2"
            :min="0" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_943')">
          <a-radio-group
          v-decorator="decorators.is_has_deadline"
          :options="deadlineOptions"
          @change="durationChange" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_944')" v-if="isHasDeadline">
          <a-date-picker v-decorator="decorators.valid_since" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_945')" v-if="isHasDeadline">
          <a-select v-decorator="decorators.valid_duration">
            <a-select-option v-for="item in durationOptions" :key="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('scope.text_512')">
          <a-textarea
            v-decorator="decorators.notes"
            :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CreateVoucherDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      isHasDeadline: false,
      accountResultLoaded: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      decorators: {
        billing_account_id: [
          'billing_account_id',
          {
            rules: [
              { required: true, message: this.$t('scope.text_941') },
            ],
          },
        ],
        amount: [
          'amount',
          {
            rules: [
              { required: true, message: this.$t('scope.text_946') },
              { validator: this.checkMoney },
            ],
          },
        ],
        min_bill_amount: [
          'min_bill_amount',
          {
            rules: [
              { required: false, message: this.$t('scope.text_956') },
              { validator: this.checkMoney },
            ],
          },
        ],
        type: [
          'type',
          {
            rules: [
              { required: true, message: this.$t('scope.text_947') },
            ],
          },
        ],
        is_has_deadline: [
          'is_has_deadline',
          {
            initialValue: false,
          },
        ],
        valid_since: [
          'valid_since',
          {
            rules: [
              { required: true, message: this.$t('scope.text_948') },
            ],
          },
        ],
        valid_duration: [
          'valid_duration',
          {
            rules: [
              { required: true, message: this.$t('scope.text_949') },
            ],
          },
        ],
        notes: [
          'notes',
        ],
      },
      accountParams: {
        limit: 0,
        scope: this.$store.getters.scope,
      },
      deadlineOptions: [
        { label: this.$t('scope.text_950'), value: false },
        { label: this.$t('scope.text_943'), value: true },
      ],
      durationOptions: [
        { label: this.$t('scope.text_951'), value: '1D' },
        { label: this.$t('scope.text_952'), value: '3M' },
        { label: this.$t('scope.text_953'), value: '6M' },
        { label: this.$t('scope.text_954'), value: '1Y' },
      ],
      typeOptions: [
        { label: this.$t('scope.text_935'), value: 'redeem' },
        { label: this.$t('scope.text_936'), value: 'campaign' },
        { label: this.$t('scope.text_937'), value: 'giftcard' },
        { label: this.$t('scope.text_938'), value: 'compensation' },
      ],
    }
  },
  watch: {
    accountResultLoaded (val) {
      if (val) {
        this.form.fc.setFieldsValue({
          billing_account_id: this.params.accountId,
        })
      }
    },
  },
  methods: {
    checkMoney (rule, value, callback) {
      if (value === 0) {
        const text = this.$t('scope.text_955')
        return callback(text)
      }
      return callback()
    },
    // disabledDate (current) {
    //  return current && this.$moment(current).isBefore(this.$moment(), 'day')
    // },
    durationChange (e) {
      this.isHasDeadline = e.target.value
    },
    doCreate (data) {
      let params = {
        amount: data.amount,
        min_bill_amount: data.min_bill_amount,
        billing_account_id: data.billing_account_id,
        type: data.type,
        notes: data.notes,
      }
      if (data.is_has_deadline) {
        params = {
          ...params,
          valid_duration: data.valid_duration,
          valid_since: this.$moment(data.valid_since).format('YYYY-MM-DD'),
        }
      }
      return this.params.onManager('create', {
        managerArgs: {
          data: params,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doCreate(values)
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
